import { render, staticRenderFns } from "./juridicalPersonDataKit.vue?vue&type=template&id=0c080be6&scoped=true&"
import script from "./juridicalPersonDataKit.vue?vue&type=script&lang=js&"
export * from "./juridicalPersonDataKit.vue?vue&type=script&lang=js&"
import style0 from "./juridicalPersonDataKit.vue?vue&type=style&index=0&id=0c080be6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c080be6",
  null
  
)

export default component.exports